(function () {
  function installGuard() {
    var utils = window.lbHandlers && window.lbHandlers.utils;
    if (!utils || typeof utils.validateRule !== 'function') return;

    var validateRule = utils.validateRule;
    if (validateRule.sluggersCollectionGuard) return;

    function guardedValidateRule(rule, product, cart) {
      // Selleasy's exclusion check calls includes() on missing collection data
      // after a failed product lookup. Unknown membership must not qualify a cart.
      if (rule && rule.class === 'collection' && rule.type === 'notHave' && cart && cart.items &&
          cart.items.some(function (item) {
            return !(item.collections && Array.isArray(item.collections.nodes)) &&
              !(item.graphQLRes && item.graphQLRes.collections && Array.isArray(item.graphQLRes.collections.nodes));
          })) {
        return false;
      }
      return validateRule.apply(this, arguments);
    }

    guardedValidateRule.sluggersCollectionGuard = true;
    utils.validateRule = guardedValidateRule;
  }

  // Capture is required because script load events do not bubble. Selleasy starts
  // a fresh cart request during initialization and awaits it before cart rules run.
  document.addEventListener('load', function (event) {
    var script = event.target;
    if (script && script.tagName === 'SCRIPT' && /\/lb-upsell-[^/]+\/assets\/lb-selleasy\.js(?:[?#]|$)/.test(script.src)) {
      installGuard();
    }
  }, true);
  installGuard();
})();
